import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ClaimItem} from '../../entity/claim-item';
import {LocalizationPipePipe} from '../../../localization/control/localisation-pipe-pipe';

export type ClaimOverviewStatisticsData = {
  total: number;
  completed: number;
  under_review: number;
  rejected: number;
  ['new']: number;
}

@Component({
  selector: 'app-claim-overview-statistics-metric',
  template: `
    <div class="card">
      <div class="card-content">
        <p>
          <span class="title">{{ metricValue }}</span>
          <br/>
          <span class="is-size-6">{{ metricTitle }}</span>
        </p>
      </div>
    </div>
  `
})
export class ClaimOverviewStatisticsMetric {
  @Input() metricValue?: number;
  @Input() metricTitle?: string;
}


@Component({
  selector: 'app-claim-overview-statistics',
  templateUrl: './claim-overview-statistics.html',
  imports: [
    ClaimOverviewStatisticsMetric,
    LocalizationPipePipe
  ],
  styleUrl: './claim-overview-statistics.scss'
})
export class ClaimOverviewStatistics implements OnInit, OnChanges {
  @Input() claims: ClaimItem[] | null = null;

  protected statistics: ClaimOverviewStatisticsData = {
    total: 0,
    completed: 0,
    under_review: 0,
    rejected: 0,
    ['new']: 0
  }

  ngOnInit(): void {
    this.refreshStatistics();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.refreshStatistics();
  }

  private refreshStatistics() {
    const stats: ClaimOverviewStatisticsData = {
      total: 0,
      completed: 0,
      under_review: 0,
      rejected: 0,
      ['new']: 0
    }

    this.claims?.forEach(c => {
      const s = `${c.status}` as keyof ClaimOverviewStatisticsData;
      stats[s] = (stats[s] ?? 0) + 1
    })
    stats.total = stats.completed + stats.under_review + stats.rejected + stats['new'];
    this.statistics = stats
  }
}

